<template>
    <BaseDialog v-model:open="open" :title="title" title-style="serif">
        <!-- Sections -->
        <ul class="flex flex-col gap-4 text-center">
            <li v-for="section in sections" :key="section.title" class="flex flex-col items-center gap-1">
                <div class="flex items-center gap-2">
                    <i class="shrink-0 text-base text-ink-muted" :class="`bi ${section.icon}`" aria-hidden="true"></i>
                    <p class="body-semibold text-ink">{{ section.title }}</p>
                </div>
                <p class="body-small text-ink-muted">{{ section.description }}</p>
            </li>
        </ul>
        <template #footer><BaseButton theme="primary" size="md" @click="open = false">Got it</BaseButton></template>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";

export interface InfoModalSection {
    icon: string;
    title: string;
    description: string;
}

defineProps<{
    title: string;
    sections: InfoModalSection[];
}>();

const open = defineModel<boolean>("open", { default: false });
</script>
